import { IApiResponse, IMedicalEventResponse, IPostMedicalEvent } from 'types'
import { request } from 'services/base'
import {
  MEDICAL_EVENT_REGISTRATION,
  MEDICAL_EVENT_REGISTRATION_FILTERED
} from './CONSTANTS'

export const getMedicalEventList = async (): Promise<
  IApiResponse<IMedicalEventResponse[]>
> => await request({ url: MEDICAL_EVENT_REGISTRATION, method: 'get' })

export const addMedicalEvent = async (
  data: IPostMedicalEvent
): Promise<IApiResponse<any>> =>
  await request({ url: MEDICAL_EVENT_REGISTRATION, data, method: 'post' })

export const deleteMedicalEvent = async (
  medical_event_id: string
): Promise<IApiResponse<any>> =>
  await request({
    url: MEDICAL_EVENT_REGISTRATION_FILTERED(medical_event_id),
    method: 'delete'
  })
